module.exports = __webpack_public_path__ + "static/media/icon_account_on.221c6645.svg";